export default "__VITE_ASSET__CPYs2jHA__"